import React, { useState, useEffect } from 'react';

import Grid from '@mui/material/Grid2';

import { 
  FeatFeature,
} from "@dndModels";
import { FEAT_TIERS } from "@dndModels/Constants";
import { FeatTier } from "@dndModels/Types";

import SelectStringBox from "@components/input/selects/SelectStringBox";
import SelectObjectBox from "@components/input/selects/SelectObjectBoxSimple";
import CheckBox from "@components/input/CheckBox";
import SuggestionStringBox from '@dndComponents/select/SuggestionStringBox';

interface Props {
  obj: FeatFeature;
  onChange: (changed: FeatFeature) => void; 
  change_time: number;
  disabled: boolean;
}

export default function FeatFeatureInput({ 
  obj,
  onChange,
  change_time,
  disabled = false 
}: Props) {
  const [my_obj, setObj] = useState(obj);
  const [prev_change_time, setChangeTime] = useState(change_time);
  const [reloading, setReloading] = useState(false);

  useEffect(() => {
    if (change_time !== prev_change_time) {
      setObj(obj);
      setChangeTime(change_time);
      // setReloading(true);
    }
    // eslint-disable-next-line
  }, [change_time]);

  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  if (reloading) {
    return <></>;
  } else {
    const filter: any = {};
    // if (my_obj.max_level > 0) { 
    //   const levels: number[] = [];
    //   for (let i = 1; i <= my_obj.max_level; ++i) {
    //     levels.push(i);
    //   }
    //   filter = { level: { "in" : levels }};
    // }
    return (
      <Grid container spacing={0} direction="row">
        <Grid size={4}>
          <CheckBox
            name="Standard"
            value={my_obj.standard} 
            disabled={disabled}
            onChange={(changed: boolean) => {
              const new_obj = my_obj;
              new_obj.standard = changed;
              onChange(new_obj);
              setObj(new_obj);
            }} 
          />
        </Grid>
        <Grid size={4}>
          { !my_obj.standard && 
            <SelectStringBox 
              name="Feat Types"
              values={ obj.feat_tiers } 
              options={FEAT_TIERS}
              disabled={disabled}
              multiple
              onChange={(changed: FeatTier[]) => {
                const new_obj = my_obj;
                new_obj.feat_tiers = changed;
                onChange(new_obj);
                setObj(new_obj);
              }}
            />
          }
        </Grid>
        <Grid size={4}>
          { !my_obj.standard && 
            <SuggestionStringBox 
              name="Feat Tags"
              values={ obj.feat_tags } 
              field="feat_tags"
              disabled={disabled}
              multiple
              onChange={(changed: string[]) => {
                const new_obj = my_obj;
                new_obj.feat_tags = changed;
                onChange(new_obj);
                setObj(new_obj);
              }}
            />
          }
        </Grid>
        <Grid size={12}>
          <SelectObjectBox 
            name="Feat Options"
            data_type="feat"
            filter={filter}
            values={my_obj.feat_ids} 
            disabled={disabled}
            extra_options={["Any"]}
            multiple
            auto_sort
            onChange={(changed: string[]) => {
              const new_obj = my_obj;
              new_obj.feat_ids = changed;
              onChange(new_obj);
              setObj(new_obj);
            }} 
          />
        </Grid>
        <Grid size={12}>
          <SelectObjectBox 
            name="Suggested"
            data_type="feat"
            filter={filter}
            value={my_obj.suggested} 
            disabled={disabled}
            extra_options={["None"]}
            auto_sort
            onChange={(changed: string) => {
              const new_obj = my_obj;
              new_obj.suggested = changed;
              onChange(new_obj);
              setObj(new_obj);
            }} 
          />
        </Grid>
      </Grid>
    );
  }
}
